import { useUrlSearchParams } from '@dai/common'
import { TitledPaper } from '@dai/components'
import { Alert, Button } from '@mui/material'
import { logAnalyticsEvent } from 'api/Firebase'
import { useEffect } from 'react'

import useT from '@/i18n/useT'

import { AccountSetUpParams } from '../accountSetUpConfig'
import { AccountSetUpStepProps } from '../types'

type PaymentSuccessProps = AccountSetUpStepProps

function PaymentSuccess(props: PaymentSuccessProps) {
  const { user, nextStep } = props
  const { t } = useT()
  const { state: urlState } = useUrlSearchParams<AccountSetUpParams>()
  const paymentSuccess = urlState?.session_id

  useEffect(() => {
    if (user?.activeSubscription && paymentSuccess) {
      logAnalyticsEvent('payment_succeeded', {
        plan: user.activeSubscription,
      })
    }
  }, [user?.activeSubscription, paymentSuccess])

  return (
    <TitledPaper title={t('paymentSuccess.title')}>
      <Alert severity="success">{t('paymentSuccess.successMessage')}</Alert>
      <Button
        fullWidth
        color="primary"
        variant="contained"
        onClick={() => nextStep()}
        size="large"
        sx={{ mt: 3 }}
      >
        Continue
      </Button>
    </TitledPaper>
  )
}

export default PaymentSuccess
